import React, { useEffect, useState, useCallback } from "react";

let externalShow = null;

export const showAppToast = (msg) => {
  if (externalShow) externalShow(msg);
};

export const ToastHost = () => {
  const [msg, setMsg] = useState("");
  const [visible, setVisible] = useState(false);

  const show = useCallback((m) => {
    setMsg(m);
    setVisible(true);
  }, []);

  useEffect(() => {
    externalShow = show;
    return () => { externalShow = null; };
  }, [show]);

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => setVisible(false), 2500);
    return () => clearTimeout(t);
  }, [visible, msg]);

  return (
    <div
      data-testid="app-toast"
      role="status"
      aria-live="polite"
      className={`fixed bottom-4 right-4 z-[100] transition-all duration-200 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2 pointer-events-none"
      }`}
    >
      <div
        className="text-sm font-medium px-4 py-3 rounded-md max-w-xs"
        style={{
          background: "var(--brand-primary)",
          color: "var(--ink-on-brand)",
          boxShadow: "var(--shadow-hover)",
          transition: "opacity var(--duration-base) var(--ease-standard), transform var(--duration-base) var(--ease-standard)",
        }}
      >
        {msg}
      </div>
    </div>
  );
};
